import React from 'react';
import PageWrapper from './PageWrapper';
import EditableText from './EditableText';

export default function OutlinePage({ data, personName }) {
  const entries = Object.entries(data.content || {});

  return (
    <PageWrapper pageNumber={4} personName={personName}>
      <EditableText
        as="h2"
        className="pdf-section-heading"
        path="outlineOfThisReport.sectionHeading"
        variant="inline"
        stripInlineWrap
      />

      <div className="outline-list">
        {entries.map(([title, description], idx) => (
          <div key={idx} className="outline-item">
            <div className="outline-item__badge">{idx + 1}</div>
            <div className="outline-item__content">
              <h4 className="outline-item__title">{title}</h4>
              <p className="outline-item__desc">{description}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="outline-how-to-use">
        <EditableText
          as="h4"
          className="outline-how-to-use__heading"
          path="outlineOfThisReport.howToUseHeading"
          variant="inline"
          stripInlineWrap
        />
        <EditableText
          as="div"
          className="outline-how-to-use__list-wrap"
          path="outlineOfThisReport.howToUseTips"
          variant="block"
        />
      </div>
    </PageWrapper>
  );
}
